export default {"src":"/_next/static/media/line-03.3f3b024c.svg","height":1,"width":123,"blurWidth":0,"blurHeight":0};